/* tslint:disable */
/* eslint-disable */
export enum ImpactType {
  Direct = 'DIRECT',
  Indirect = 'INDIRECT',
  Enabling = 'ENABLING',
}
